import ProductCardSelectors from '../shared/product-card/selectors';
import VariantHandler from './variant-handler';
import AddToCartHandler from '../shared/product/add-to-cart-handler';
import { PRODUCT_CARD } from '../classnames/product-card';

export default class ProductCard {
  constructor() {
    this.selectors = new ProductCardSelectors();
    this.containers = [...document.getElementsByClassName(PRODUCT_CARD)];
    this.variantHandler = new VariantHandler(this.containers);
    this.addToCartHandler = new AddToCartHandler(this.selectors, this.containers);
  }

  initializeEventListeners = () => {
    this.addToCartHandler.initializeEventListeners();
    this.variantHandler.initializeEventListeners();
  };
}
